// extracted by mini-css-extract-plugin
export default {"heading":"BasicInformation_heading__zKAdr","wrapper":"BasicInformation_wrapper__2Lotp"};